module.exports = __webpack_public_path__ + "static/media/buttsim.4937f5d3.png";